import { getHarvestYearValidationMessage } from "../../../../utils/utils";
import { FieldDataValues } from "../types/cultivarForm.types";

export const getHarvestYearError = (fieldData: FieldDataValues | null): string | null =>
  getHarvestYearValidationMessage(fieldData?.harvestYear);
